import { arduinoGenerator } from './arduino-generator.js';

/** Hidden from students — Serial Monitor always starts at a fixed baud. */
export const BEGINNER_SERIAL_BAUD = '9600';

export function ensureBeginnerSerialSetup(): void {
  arduinoGenerator.addSetupOnce(
    'beginner-serial',
    `Serial.begin(${BEGINNER_SERIAL_BAUD});`,
  );
}
